export default "__VITE_ASSET__D_pC2Iz0__"